import { ISubmitOrderRequestProduct } from '../app/store/order/basic/types';
import { AppState } from '../app/store/rootReducers';
import { OrderConstants } from '../constants/OrderConstants';
import { isAdditionalProducts } from './util';
import { getAdditionalProducts } from './additionalProductsUtils';
import { deviceTypes } from '../constants/TelcoDeviceTypes';
import ProductTypes from '../constants/ProductTypes';
import { OrderItemsTypes } from '../constants/OrderItemsTypes';

export const getOrderSubmitParams = (state: AppState): ISubmitOrderRequestProduct => {
  const section = state.section?.section;
  const greenVoucher = state.greenVoucher;
  const productInsurances = state.productInsurances;
  const activeProductData = state.productData;
  const greenVoucherCode = greenVoucher.voucherSerialNumber ? greenVoucher.voucherSerialNumber : '';
  const installmentsNumber = activeProductData?.productData?.cosmosInstallments;
  const isComplexOrder =
    getAdditionalProducts().length > 0 &&
    activeProductData.product?.item?.productLine?.productLine === OrderItemsTypes.PHONE;

  // Add campaign data, or just set that param to null.
  const oreSubmitData = state.campaign?.campaignMode?.oreSubmitData;
  const tariffPackageSelected = oreSubmitData?.product?.tariffPackages?.find(
    (tariffPackage: any) => tariffPackage.id === activeProductData.productData.tariff
  );
  const featuredAndUnfeaturedTariffPackages = oreSubmitData?.oreOffer?.featuredPackages.concat(
    oreSubmitData?.oreOffer?.unFeaturedPackages
  );
  const valid = oreSubmitData
    ? featuredAndUnfeaturedTariffPackages?.find(
      (campaignTariffPackage: any) => campaignTariffPackage.tmCode === tariffPackageSelected?.tmCode
    )?.id
    : null;
  const campaign = oreSubmitData
    ? {
      valid,
      offerId: oreSubmitData.oreOffer.offerId,
      optionId: oreSubmitData.oreOffer.id,
      channel: oreSubmitData.channel,
      lsId: 0,
    }
    : null;

  // Complex order ide samo uz telefon na 24 ili 36 rata, što znači da dodatna oprema mora imati 24 rate (i odgovarajuću ugovornu obavezu).
  // U slučaju kupovina koje nisu telco nemamo mogućnost complex korpe pa additional products prate glavni proizvod (prosleđujemo installmentsNumber).
  const additionalProducts = prepareAdditionalProducts(isComplexOrder ? 24 : installmentsNumber);

  const isRecyclingApplicable = greenVoucher.voucherApplied || greenVoucher.deviceNumberSpecified;

  const submitOrderParams: ISubmitOrderRequestProduct = {
    segment: section,
    gRecaptchaResponse: '',
    selectedProducts: [
      {
        id: Number(activeProductData.product.item.id),
        productLine: activeProductData.product.item.productLine.productLine,
        purchaseType: activeProductData.productData.purchase,
        contractDuration: activeProductData.productData.contract,
        tariffPackageId: activeProductData.productData.tariff,
        colorId: parseInt(activeProductData.productData.color),
        cosmos: null,
        subsidy: null,
        recycle: greenVoucher.voucherApplied ? false : isRecyclingApplicable,
        voucher: greenVoucher.voucherApplied ? greenVoucherCode : undefined,
        numberOfDevices: greenVoucher.voucherApplied ? undefined : greenVoucher.numberOfDevices,
        insurance: productInsurances.selectedInsurance,
        campaign,
      },
      ...additionalProducts,
    ],
    lang: state.language.language,
  };

  // Add additional submitOrder params for COSMOS if it is set
  if (activeProductData.productData.purchase === OrderConstants.purchases.COSMOS) {
    submitOrderParams.selectedProducts[0].installments = activeProductData.productData.cosmosInstallments;
    submitOrderParams.selectedProducts[0].contractDuration = activeProductData.productData.cosmosInstallments === 36 ? 24 : activeProductData.productData.cosmosInstallments;
    submitOrderParams.selectedProducts[0].cosmos = {
      cosmosModel: activeProductData.productData.cosmosModel,
      participation: activeProductData.productData.participation,
    };
  }

  if (activeProductData.productData.purchase === OrderConstants.purchases.SUBSIDY) {
    submitOrderParams.selectedProducts[0].installments = 0;
    submitOrderParams.selectedProducts[0].subsidy = {
      installmentOverBillPeriod: activeProductData.productData.installments ? 6 : 0,
    };
  }

  return submitOrderParams;
};

export const stateHasOrderSubmitParams = (state: AppState): boolean => {
  const productDataHasSuggestedProducts = deviceTypes.includes(state.productData.product.item.productLine.productLine);
  const phoneOrTabletProductLine = [ProductTypes.TABLET, ProductTypes.PHONE].includes(
    state.productData.product.item.productLine.productLine
  );

  const urlMatchesAdditionalProductsPage = isAdditionalProducts();
  const suggestedProducts = state.productSuggestions.items;

  return !(
    productDataHasSuggestedProducts &&
    !urlMatchesAdditionalProductsPage &&
    (phoneOrTabletProductLine || suggestedProducts.length > 0)
  );
};

export const prepareAdditionalProducts = (installments: number) => {
  const additionalProducts = getAdditionalProducts();
  const additionalProductsForSubmit = additionalProducts.map((item: any) => {
    return {
      id: Number(item.id),
      productLine: item.productLine,
      purchaseType: 'cosmos',
      colorId: parseInt(item.colorId),
      cosmos: {
        cosmosModel: 'telco',
        participation: 0,
      },
      // Za dodatnu opremu u kompleksnoj korpi, contractDuration i installments će uvek biti prosleđena vrednost (24).
      contractDuration: installments,
      installments,
      quantity: item.itemCount,
    };
  });

  return additionalProductsForSubmit;
};
